export default {
  "fontElementMap": "_09VQj",
  "orderedlist": "cb8Me",
  "bulletedlist": "hNyvo",
  "listItem": "q-8IS"
};